module.exports = __webpack_public_path__ + "media/images/new/icons/instagram@2x-9127d99198498ce8331a5f1aba640ad1.png";